import autoTable from "jspdf-autotable";

import {
  PDF_TABLE_STYLE,
  PDFCOLORSHEME,
} from "../../../../../../component/constent";

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function drawShopTable(
  doc,
  shop,
  rows,
  total
) {
  /*
   * Allocation tables belong to the current Demand page.
   *
   * DO NOT call doc.addPage() here.
   *
   * autoTable will automatically create another page
   * when the allocation table does not fit.
   */

  const startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 14
    : 42;

  const columnStyles = {
    0: {
      cellWidth: 40,
      halign: "left",
    },

    1: {
      cellWidth: 40,
      halign: "right",
    },

    2: {
      cellWidth: 38,
      halign: "right",
    },

    3: {
      cellWidth: 38,
      halign: "right",
    },

    4: {
      cellWidth: 38,
      halign: "right",
    },

    5: {
      cellWidth: 38,
      halign: "right",
    },

    6: {
      cellWidth: 38,
      halign: "right",
    },
  };

  // =====================================================
  // ALLOCATION HEADER
  // =====================================================

  doc.setFillColor(
    PDFCOLORSHEME.BACK_COLOR_GROUP
  );

  doc.rect(
    14,
    startY - 10,
    270,
    8,
    "F"
  );

  doc.setTextColor(
    PDFCOLORSHEME.FONT_COLOR_GROUP
  );

  doc.setFont("helvetica", "bold");

  doc.setFontSize(
    PDFCOLORSHEME.FONT_SIZE_GROUP
  );

  doc.text(
    String(shop || "Unknown"),
    20,
    startY - 5
  );

  // =====================================================
  // DETAIL TABLE
  // =====================================================

  autoTable(doc, {
    startY,

    ...PDF_TABLE_STYLE,

    head: [
      [
        "ALLOCATION HEAD",
        "WORK ORDER",
        "DIRECT LABOUR",
        "DIRECT STORE",
        "ON COST LABOUR",
        "ON COST STORE",
        "Total",
      ],
    ],

    body: rows.map((r) => {
      const dl = Number(
        r["DIRECT LABOUR"] || 0
      );

      const ds = Number(
        r["DIRECT STORE"] || 0
      );

      const ocl = Number(
        r["ON COST LABOUR"] || 0
      );

      const ocs = Number(
        r["ON COST STORE"] || 0
      );

      const totalAmount =
        dl + ds + ocl + ocs;

      return [
        r.Allocation || "",
        r.WORKORDER || "",
        format(dl),
        format(ds),
        format(ocl),
        format(ocs),
        format(totalAmount),
      ];
    }),

    styles: {
      fontSize:
        PDFCOLORSHEME.FONT_SIZE_BODY,

      halign: "right",
    },

    headStyles: {
      fillColor:
        PDFCOLORSHEME.BACK_COLOR_HEADER,

      textColor:
        PDFCOLORSHEME.FONT_COLOR_HEADER,

      halign: "center",

      fontStyle: "bold",
    },

    columnStyles,

    margin: {
      left: 14,
      right: 13,
    },
  });

  // =====================================================
  // ALLOCATION TOTAL
  // =====================================================

  const y =
    doc.lastAutoTable.finalY + 2;

  const pageHeight =
    doc.internal.pageSize.getHeight();

  /*
   * If the allocation total itself does not fit,
   * create a page and draw the total there.
   */
  if (y > pageHeight - 15) {
    doc.addPage();

    const newY = 20;

    drawAllocationTotal(
      doc,
      shop,
      total,
      newY
    );

    doc.lastAutoTable.finalY =
      newY + 8;

    return;
  }

  drawAllocationTotal(
    doc,
    shop,
    total,
    y
  );

  // Save final position
  doc.lastAutoTable.finalY =
    y + 8;
}


// =====================================================
// ALLOCATION TOTAL
// =====================================================

function drawAllocationTotal(
  doc,
  shop,
  total = {},
  y
) {
  doc.setFillColor(
    PDFCOLORSHEME.BACK_COLOR_TOTAL
  );

  doc.rect(
    14,
    y,
    270,
    8,
    "F"
  );

  doc.setTextColor(
    PDFCOLORSHEME.FONT_COLOR_TOTAL
  );

  doc.setFont("helvetica", "bold");

  doc.setFontSize(
    PDFCOLORSHEME.FONT_SIZE_TOTAL
  );

  // Allocation label
  doc.text(
    `${shop || "Unknown"} Total`,
    16,
    y + 5
  );

  // Direct Labour
  doc.text(
    format(total.dl),
    130,
    y + 5,
    {
      align: "right",
    }
  );

  // Direct Store
  doc.text(
    format(total.ds),
    167,
    y + 5,
    {
      align: "right",
    }
  );

  // On Cost Labour
  doc.text(
    format(total.ocl),
    205,
    y + 5,
    {
      align: "right",
    }
  );

  // On Cost Store
  doc.text(
    format(total.ocs),
    243,
    y + 5,
    {
      align: "right",
    }
  );

  // Total
  doc.text(
    format(total.total),
    280,
    y + 5,
    {
      align: "right",
    }
  );

  doc.setTextColor(0);
}